(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/my-orders.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/my-orders.js');
"use strict";

const _React = React,
  Suspense = _React.Suspense,
  useRef = _React.useRef,
  Fragment = _React.Fragment;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const ErrorBoundary = svs.ticket_partner.sharedComponents.errorBoundary.ErrorBoundary;
const InformationPanels = svs.ticket_partner.sharedComponents.informationPanels.InformationPanels;
const HEADER = svs.ticket_partner.myOrders.constants.TEXTS.HEADER;
const _svs$ticket_partner$m = svs.ticket_partner.myOrders.components,
  Orders = _svs$ticket_partner$m.Orders,
  ValidateVoucher = _svs$ticket_partner$m.ValidateVoucher;
const Loader = svs.ticket_partner.sharedComponents.loader.Loader;
const PageWrapper = svs.ticket_partner.sharedComponents.pageWrapper.PageWrapper;
const MyOrders = () => {
  var _svs$ticket_partner$d;
  const loaderRef = useRef();
  return React.createElement(Fragment, null, React.createElement(PageWrapper, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 8
    },
    xs: 12
  }, React.createElement("h1", null, HEADER), React.createElement("div", {
    ref: loaderRef
  }, React.createElement(ErrorBoundary, {
    errorComponent: React.createElement("h2", null, "Kan inte h\xE4mta best\xE4llningar just nu")
  }, React.createElement(Suspense, {
    fallback: React.createElement(Loader, {
      elementRef: loaderRef
    })
  }, React.createElement(Orders, null)))))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 8
    },
    xs: 12
  }, React.createElement(ValidateVoucher, null)))), React.createElement(InformationPanels, {
    articles: (_svs$ticket_partner$d = svs.ticket_partner.data) === null || _svs$ticket_partner$d === void 0 || (_svs$ticket_partner$d = _svs$ticket_partner$d.articles) === null || _svs$ticket_partner$d === void 0 ? void 0 : _svs$ticket_partner$d.myOrdersArticles
  }));
};
svs.ticket_partner.myOrders.MyOrders = MyOrders;

 })(window);